var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:( _obj = {
    'section parent row wrap h-between padding-top_base': true, 
    'container': _vm.isContainer
}, _obj['section_' + _vm.modifier] = _vm.modifier, _obj[_vm.className] = _vm.className, _obj )},[_c('h2',{staticClass:"relative text_upper section__title endlessBottomBorder endlessBottomBorder_gray padding-bottom_small"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("default")],2)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bd40596","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionContainer.vue
// module id = null
// module chunks = 